const parties = [
  {
    level: 0,
    party: "sd",
    intro: "Sverigedemokraterna",
    description: "Jimmie Åkesson, tjala lala la~",
    color: "rgb(251, 199, 0)",
  },
  {
    level: 1,
    party: "kd",
    intro: "Kristdemokraterna",
    description:
      "SDs förslag kan ibland kännas lite väl hårda, men om man strösslar formuleringarna med lite kristen värdegrund så låter dom ju faktiskt ganska fräcka!",
    color: "rgb(0, 94, 161)",
  },
  {
    level: 2,
    party: "m",
    intro: "Moderaterna",
    description:
      "En gång i tiden var SD paria men längtan efter makten tog till slut överhanden. Dom funkar dock bra som frontlinje för din favoritpolitik, låt SD gå ut med sina kontroversiella förslag först och se vad som flyger, och sen tre månader senare lanserar ni samma förslag med snyggare retorik.",
    color: "rgb(82, 189, 236)",
  },
  {
    level: 3,
    party: "l",
    intro: "Liberalerna",
    description:
      "SD står för allt du inte står för, men en av sakerna du står för är att man ska kunna prata med alla. Så nu står vi här.",
    color: "rgb(0, 106, 179)",
  },
  {
    level: 4,
    party: "s",
    intro: "Socialdemokraterna",
    description:
      "Du är helt okej med åtstramad migrationspolitik och socialt ingenjörsskap i utsatta områden, men i så fall ska det vara för att Morgan Johansson säger det, inte Tobias Andersson.",
    color: "rgb(237, 27, 52)",
  },
  {
    level: 5,
    party: "v",
    intro: "Vänsterpartiet",
    description:
      "I regel så är det väldigt angeläget att inte tycka likadant som SD, men man kan såklart göra undantag i hjärtefrågor. Typ som att rösta bort en S-regering.",
    color: "rgb(218, 41, 28)",
  },
  {
    level: 6,
    party: "c",
    intro: "Centerpartiet",
    description:
      "För dig är ingen fråga så viktig att den går att tycka, om SD också tycker den. Förutom det gemensamma föraktet emot Vänsterpartiet.",
    color: "rgb(17, 72, 56)",
  },
  {
    level: 7,
    party: "mp",
    intro: "Miljöpartiet",
    description:
      "Om SD är äpplen så är du päron. Det går helt enkelt inte att jämföra er. Du vill vara så långt ifrån Sverigedemokraterna som det bara går, och då står valet mellan Danmarkfascistera och Miljöpartiet, varav det ena inte existerar.",
    color: "rgb(83, 160, 69)",
  },
];

export default parties;
